// 「홈 화면에 설치」 안내 — 설치 가능하면 늘 뜬다. 닫으면 지금 화면에서만 숨고, 다시 들어오면 또 뜬다.
//
// [왜 띄우나] 설치한 기기는 브라우저가 저장을 **영구로** 올려 줘서 받아 둔 지형·모델
//   캐시가 안 버려진다. 즉 이 배너는 편의가 아니라 **로딩 시간**을 지키는 장치다.
// [언제 안 뜨나] 이미 설치된 판(standalone) · 설치 이벤트가 없는 브라우저(iOS 사파리) ·
//   사용자가 닫은 뒤. 로그인 화면에서도 뜬다 — 게임에 들어가기 «전»에 깔아야 값이 있다.

import React, { useEffect, useState } from 'react';
import { subscribe, install, isStandalone } from '@engine/pwaInstall';

export default function InstallBanner({ gameRoute = false }) {
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [canInstall, setCanInstall] = useState(false);
  const [message, setMessage] = useState('');
  useEffect(() => {
    if (isStandalone()) return undefined;
    return subscribe((s) => {
      setCanInstall(s.canInstall && !s.installed);
      // 개발 주소에서 설치 가능 이벤트를 흉내 내며 띄우던 배너는, 설치된 앱에도 계속 나타났다.
      // 실제 설치 가능 이벤트가 있는 브라우저에서만 노출해 이미 설치된 앱은 자동으로 제외한다.
      setShow(!s.installed && s.canInstall);
    });
  }, []);

  // 인게임 HUD 위에 설치 권유가 겹치지 않게 한다. 게임 중에는 시스템 정보 패널에도 설치 경로가 있다.
  if (!show || gameRoute) return null;

  const close = () => {
    setShow(false);
  };

  return (
    // `data-ui` 는 촬영 스크립트가 컷에서 이 배너를 걷어내는 손잡이다 —
    // 인라인 스타일뿐이라 달리 잡을 자리가 없다. 화면 동작과는 무관하다.
    <div
      data-ui="install-banner"
      className="pwa-install-banner"
      style={{
      /* ★ 화면 «위»에 붙인다. 아래는 하단 바 + 비모달 패널들이 이미 쓰는 자리라, 여기 두면
           사용자가 «연» 패널의 버튼을 이 배너가 덮는다. z 를 낮춰도 안 되는데, 배너와 패널이
           서로 다른 스택 맥락(부모가 다르다)에 있어 z 값끼리 겨루지 않기 때문이다.
           브라우저 설치 권유가 위에서 내려오는 관행과도 맞는다. */
      position: 'fixed', left: 16, top: 16, zIndex: 7900,
      display: 'flex', alignItems: 'center', gap: 12, width: 'min(360px, calc(100vw - 24px))',
      boxSizing: 'border-box',
      padding: '12px 14px', borderRadius: 12, border: '1px solid rgba(214,182,110,.45)',
      background: 'rgba(20,16,12,.94)', color: '#f3e7cf', boxShadow: '0 8px 28px rgba(0,0,0,.5)',
      fontSize: 14, lineHeight: 1.45,
    }}
    >
      <div className="pwa-install-banner__copy" style={{ flex: 1, minWidth: 0 }}>
        <b style={{ color: '#f0d9a0' }}>브로큰을 앱으로 설치</b>
        <div style={{ opacity: 0.85, fontSize: 13 }}>
          {message || '설치하면 받아 둔 지형·모델이 유지돼 다음부터 더 빨리 열립니다.'}
        </div>
      </div>
      <button
        type="button"
        className="pwa-install-banner__action"
        disabled={busy || !canInstall}
        onClick={async () => {
          setBusy(true);
          const result = await install();
          setBusy(false);
          if (result === 'accepted') close();
          else if (result === 'unavailable') setMessage('Chrome 오른쪽 위 ⋮ → 앱 설치 또는 페이지를 앱으로 설치를 선택하세요.');
          else if (result === 'dismissed') setMessage('Chrome 설치 확인 창에서 취소했습니다. 필요하면 다시 설치 버튼을 누르세요.');
          else setMessage('Chrome 설치 창을 열지 못했습니다. 오른쪽 위 ⋮ → 앱 설치를 이용하세요.');
        }}
        style={{
          padding: '8px 14px', borderRadius: 8, border: '1px solid rgba(214,182,110,.6)',
          background: 'linear-gradient(180deg,#e3c37e,#b9924a)', color: '#241a0c',
          fontWeight: 700, cursor: canInstall ? 'pointer' : 'default', whiteSpace: 'nowrap',
          opacity: canInstall ? 1 : 0.58,
        }}
      >
        {busy ? '여는 중…' : canInstall ? 'Local 설치' : '설치 대기'}
      </button>
      <button
        type="button"
        className="pwa-install-banner__action"
        onClick={close}
        aria-label="설치 안내 닫기"
        style={{
          padding: '8px 10px', borderRadius: 8, border: '1px solid rgba(255,255,255,.18)',
          background: 'transparent', color: '#cbbfa8', cursor: 'pointer',
        }}
      >
        나중에
      </button>
    </div>
  );
}
